import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import React from 'react';

const Wrapper = styled.div``;
const LogoWrapper = styled.div`
  max-height: 12rem;
  max-width: 12rem;
  margin: 0 auto 0.5rem auto;
  position: relative;
  z-index: 0;
  text-align: center;
`;
const ActiveImg = styled.img`
  cursor: pointer;
  height: 12rem;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
const ImageList = styled.div`
  position: relative;
  width: 12rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto 2rem auto;
`;
const ImageListItem = styled.img<{ isActive: boolean }>`
  width: 4rem;
  position: relative;
  border: ${(props) => props.isActive && 'solid 2px' + colors.primaryBlue_500};
  cursor: pointer;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
const ImageMask = styled.div`
  position: absolute;
  right: 0;
  background-color: rgba(75, 75, 75, 0.7);
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  border-radius: 6px;
`;

interface Iprops {
  imageUrls: string[];
  setIsZoomOpen: (isOpen: boolean) => void;
  activeImageIdx: number;
  setActiveImageIdx: (idx: number) => void;
}

const TmarkImages: React.FC<Iprops> = ({
  imageUrls,
  setIsZoomOpen,
  activeImageIdx,
  setActiveImageIdx,
}) => {
  const isMoreThanThree = imageUrls.length > 3;

  return (
    <Wrapper>
      <LogoWrapper>
        <ActiveImg
          src={imageUrls && imageUrls[activeImageIdx]}
          onClick={() => setIsZoomOpen(true)}
		  alt=""
        />
      </LogoWrapper>
      {imageUrls && imageUrls.length > 1 && (
        <ImageList>
          {imageUrls.map((url, idx) => {
            const isLastDisplayItem = idx === 2;
            const isShouldBeHidden = idx > 2;
            const hiddenNum = imageUrls.length - 3;
            return isShouldBeHidden ? (
              <React.Fragment key={idx}></React.Fragment>
            ) : (
              <React.Fragment key={idx}>
                <ImageListItem
                  src={url}
                  alt=""
                  isActive={activeImageIdx === idx}
                  onClick={() => {
                    setActiveImageIdx(idx);
                  }}
                />
                {isLastDisplayItem && isMoreThanThree && (
                  <ImageMask onClick={() => setIsZoomOpen(true)}>+{hiddenNum}</ImageMask>
                )}
              </React.Fragment>
            );
          })}
        </ImageList>
      )}
    </Wrapper>
  );
};

export default TmarkImages;
